export enum CollapsibleBlockModifier {
  EDITMODE = 'collapsible-block--editmode',
  NO_BORDER = 'collapsible-block--no-border',
  LIGHT = 'collapsible-block--light',
  LARGE_HEADLINE = 'collapsible-block--large-headline',
}
